import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeleteRedirect($id: Int!) {
    deleteRedirect(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteRedirect: {
    id?: number;
  };
}
